import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PathNotFound from '@/views/error.vue'
import support from '@/views/supportForm.vue'
import SubmissionSuccessView from '@/views/SubmissionSuccessView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    // component: HomeView,
    redirect: 'registration'
  },
  {
    path: '/registration',
    name: 'registration',
    component: HomeView
  },
  {
    path: '/support',
    name: 'support',
    component: support
  },
  {
    path: '/registration-success',
    name: 'registration-success',
    component: SubmissionSuccessView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  { path: '/:pathMatch(.*)*', component: PathNotFound },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
